"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTeamReferenceSchema = void 0;
exports.ExternalTeamReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/external-teams.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ExternalTeamReference",
    "description": "A Team that is not sponsored by Red Bull, but might still take part in a Red Bull competition or event.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:external-teams"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZXJuYWwtdGVhbXMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2NvbnRlbnQvZXh0ZXJuYWwtdGVhbXMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsMkJBQTJCLEdBQUc7SUFDekMsS0FBSyxFQUFFLDhFQUE4RTtJQUNyRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx1QkFBdUI7SUFDaEMsYUFBYSxFQUFFLHlHQUF5RztJQUN4SCxNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLDJCQUEyQjthQUM1QjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLDZFQUE2RTtTQUN6RjtLQUNGO0NBQ0YsQ0FBQSJ9